export default __webpack_public_path__ + "static/media/CNo.41-1.deedb6dd.jpg";